import React from 'react';
import Error from '../../ui/Error'

const Fehler = () => {
	return <Error />;
}


export default Fehler;